const customDropdown = function () {
  /*
  * Get how many dropdowns defined and to know which one is focused.
  */
  var selectDropdown = jQuery('.select-dropdown');
  for (let i = 0; i < selectDropdown.length; i++) {
    var openedSelectDropdown = selectDropdown[i];
    jQuery(openedSelectDropdown).unbind('click').on('click', function () {
      // ToggleClass for dropdowns
      if (jQuery(this).parent().hasClass('active')) {
        jQuery(this).parent().removeClass('active');
        jQuery(this).removeClass('active').find('.dropdown-select-input.country-form').attr({
          'aria-expanded': 'false'
        });
      } else {
        jQuery('.fworks-custom-dropdown, .select-dropdown').removeClass('active');
        jQuery(this).parent().addClass('active');
        jQuery(this).addClass('active').find('.dropdown-select-input.country-form').attr({
          'aria-expanded': 'true'
        });
      }
      // focus if search-input field available
      if (jQuery(this).parent().find('.search-input input')) {
        jQuery(this).parent().find('.search-input input').focus();
      }
      if (jQuery('.fworks-custom-dropdown .form-field').hasClass('error')) {
        jQuery('.fworks-custom-dropdown .form-field').removeClass('error');
      }
      // Change/Update list item values to active dropdown input
      jQuery('.dropdown-content .option').unbind('mousedown').on('mousedown', function () {
        jQuery('.dropdown-content .option').removeAttr('selected');
        jQuery(this).attr('selected', 'selected');
        var value = jQuery(this).text().trim();
        var updateCurrInputValue = jQuery('.fworks-custom-dropdown.active .dropdown-select-input');
        // Country based dropdown
        var isoCode = jQuery(this).attr('data-country-code');
        var phoneCountryCode = jQuery(this).attr('phone-country-code');
        var updateCountryFlag = jQuery('.fworks-custom-dropdown.active .dropdown-select-input.-country');
        if (typeof isoCode !== 'undefined') {
          jQuery('#country-icon').css({ visibility: 'hidden' });
          updateCurrInputValue.attr('data-iso-code', isoCode);
          if (typeof phoneCountryCode !== 'undefined') {
            updateCurrInputValue.attr('phone-country-code', phoneCountryCode);
            jQuery('#cc-flag').attr('class', 'dropdown-select-input flag flag-' + isoCode);
            updateCurrInputValue.val(phoneCountryCode);
            if (!updateCurrInputValue.next().hasClass('placeholder-fix')) {
              updateCurrInputValue.next().addClass('placeholder-fix');
            }
          } else {
            updateCurrInputValue.prev('.flag').remove();
            updateCountryFlag.before('<i class="flag flag-' + isoCode + '"></i>');
            updateCurrInputValue.attr('value', value).change();
          }
        } else {
          updateCurrInputValue.attr('value', value).change();
        }
      });
    });
  }

  const closeDropdown = () => {
    jQuery('.select-dropdown').removeClass('active');
    jQuery('.dropdown-content').parent().removeClass('active');
    // Empty search input value
    jQuery('.search-country-input').val('');
    // Removing search list item display none property
    jQuery('.dropdown-content li').css('display', '');
  };
  /*
  * Close the dropdown menu if the user clicks outside of selected elements list.
  */
  jQuery(document).on('click', function (event) {
    var targetClass = '.dropdown-select-input, .dropdown-content .option, .dropdown-content .option *, .dropdown-content .filter-cb-control, .dropdown-content .filter-cb-control *, .search-country-input, ul.no-match-found';
    if (event.target.matches && !event.target.matches(targetClass)) {
      closeDropdown();
    } else {
      jQuery('.dropdown-content .option').on('click', function () {
        jQuery('.fworks-custom-dropdown.active, .select-dropdown.active').removeClass('active');
      });
    }
  });
  /*
  * Search input logic
  */
  jQuery('.search-country-input').focus(function () {
    jQuery('.fworks-custom-dropdown.active .select-dropdown').addClass('active');
    var input, filter, ul, li;
    jQuery(this).keyup(function () {
      input = jQuery(this).val();
      if (input !== '') {
        filter = input.toUpperCase();
        li = jQuery('.fworks-custom-dropdown.active .dropdown-content li');
        for (var i = 0; i < li.length; i++) {
          if (li[i].innerHTML.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = '';
          } else {
            li[i].style.display = 'none';
          }
        }
      }
      // to show a message if users search not found
      ul = jQuery('.fworks-custom-dropdown.active .dropdown-content ul');
      if (ul.height() === 0) {
        ul.addClass('no-match-found');
        ul.find('li.error').css('display', 'block');
      } else {
        ul.removeClass('no-match-found');
        ul.find('li.error').css('display', 'none');
      }
    });
  });

  (function () {
    const wrapperElements = document.querySelectorAll('.fworks-custom-dropdown') || [];

    const isCustomDropDownOpened = () => {
      let isOpened = false;
      wrapperElements.forEach((i) => {
        if (isOpened) return;
        if (jQuery(i).hasClass('active')) isOpened = true;
      });
      return isOpened;
    };

    jQuery('.general-filter-form').off('keydown').on('keydown', function (event) {
      const $this = jQuery(event.target);
      const code = event.which || event.keyCode || 0;
      if ($this.hasClass('dropdown-select-input')) {
        if ([13, 32].includes(code)) {
          event.preventDefault();
          $this.trigger('click');
        }
      } else if ($this.hasClass('option')) {
        if ([13, 32].includes(code)) {
          event.preventDefault();
          $this.trigger('mousedown').trigger('click');
        }
      } else if (!$this.hasClass('search-country-input')) {
        if ([13, 32, 9].includes(code) && isCustomDropDownOpened) closeDropdown();
      }
    });

    jQuery('.select-dropdown').on('keydown', function (event) {
      const $this = jQuery(event.target);
      const code = event.which || event.keyCode || 0;
      if ($this.hasClass('dropdown-select-input')) {
        if (code === 32) {
          jQuery(this).parent().addClass('active');
          jQuery(this).addClass('active').find('.dropdown-select-input.country-form').attr({
            'aria-expanded': 'true'
          });

          $('.fdesk-country-list').find('li').first().focus();
        }
      }
    });

    jQuery('.fdesk-country-list li').on('keydown', function (event) {
      const code = event.which || event.keyCode || 0;
      if (code === 40) {
        const totalList = $('.fdesk-country-list').find('li').length;
        const el = document.activeElement;
        const currentIndex = $('.fdesk-country-list').find(el).index();
        if (currentIndex < totalList - 1) {
          $('.fdesk-country-list').find('li')[currentIndex + 1].focus();
        }
      }
      if (code === 38) {
        const el = document.activeElement;
        const currentIndex = $('.fdesk-country-list').find(el).index();
        if (currentIndex > 0) {
          $('.fdesk-country-list').find('li')[currentIndex - 1].focus();
        }
      }
      if (code === 13) {
        const selectedValue = event.target.textContent || 0;
        if (selectedValue) {
          document.getElementById('fdesk-region-input-field').value = selectedValue;
          if (jQuery(event.target).siblings('[selected]')) {
            jQuery(event.target).siblings('[selected]').removeAttr('selected');
          }
          jQuery('#fdesk-region-input-field').attr('value', selectedValue);
          jQuery(event.target).attr('selected', 'selected');
          closeDropdown();
        }
      }
    });

    jQuery('body').on('keydown', function (event) {
      const code = event.which || event.keyCode || 0;
      if (code === 27 && isCustomDropDownOpened) closeDropdown();
    });
  }());
};

export { customDropdown };
